module.exports = __webpack_public_path__ + "static/media/ic_on_a_mission_red.1bfed06c.svg";